import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalTimeRange } from './LocalTimeRange';
/** A record of a time range which has been truncated or split. */
export class UpdatedLocalTimeRange {
    /**
     * @param before The existing time range.
     * @param after The new time ranges.
     */
    constructor(before, after) {
        this.before = before;
        this.after = after;
    }
}
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", LocalTimeRange)
], UpdatedLocalTimeRange.prototype, "before", void 0);
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", Array)
], UpdatedLocalTimeRange.prototype, "after", void 0);
